import React from "react";
import { Paper, useTheme } from "@mui/material";

interface SectionCardProps {
  children: React.ReactNode;
  variant?: "default" | "highlight";
}

const SectionCard: React.FC<SectionCardProps> = ({
  children,
  variant = "default",
}) => {
  const theme = useTheme();

  const isHighlight = variant === "highlight";

  return (
    <Paper
      elevation={0}
      sx={{
        p: 4,
        borderRadius: 2,
        border: isHighlight
          ? `2px solid ${theme.palette.primary.main}`
          : `1px solid ${theme.palette.divider}`,
        backgroundColor: theme.palette.common.white,
        boxShadow: isHighlight
          ? `0px 4px 20px ${theme.palette.primary.light}40` // 40 is hex opacity
          : "0px 2px 4px rgba(0, 0, 0, 0.05)",
        height: "100%",
        overflow: "hidden",
        width: "100%",
        scale: isHighlight ? "1.01" : "1",
        transition: "all 0.3s ease",
      }}
    >
      {children}
    </Paper>
  );
};

export default SectionCard;
